import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useModalStore = defineStore('modal', () => {
  const showDemo = ref(false)
  const showConsultor = ref(false)
  // Segmento pré-selecionado ao abrir o modal de demo a partir de uma
  // página de solução (ex.: "Conheça o Kali Pet" já leva o segmento certo).
  const demoSegmento = ref('')

  function openDemo(segmento) {
    demoSegmento.value = segmento || ''
    showDemo.value = true
  }

  function closeDemo() {
    showDemo.value = false
  }

  function openConsultor() {
    showConsultor.value = true
  }

  function closeConsultor() {
    showConsultor.value = false
  }

  return { showDemo, openDemo, closeDemo, showConsultor, openConsultor, closeConsultor, demoSegmento }
})
